import { get } from 'svelte/store';
import { persistent } from './utils';
const LOCAL_STORAGE_ENTRIES = 'saved';
const VIEWPORT_VERSION = 0;
export const savedEntries = persistent(LOCAL_STORAGE_ENTRIES, {});
export const git = persistent('git', null);
export const getEntry = (id) => {
    const saved = get(savedEntries);
    const entry = saved[id];
    return {
        version: (entry === null || entry === void 0 ? void 0 : entry.version) || -1,
        paths: (entry === null || entry === void 0 ? void 0 : entry.paths) || [],
        archived: (entry === null || entry === void 0 ? void 0 : entry.archived) || false,
    };
};
export const saveEntry = (id, { paths, archived }) => {
    const saved = get(savedEntries);
    saved[id] = {
        version: VIEWPORT_VERSION,
        paths,
        archived,
    };
    savedEntries.set(saved);
    console.debug('Saved entry', id);
};
export const deleteEntry = (id) => {
    const saved = get(savedEntries);
    delete saved[id];
    savedEntries.set(saved);
    console.debug('Deleted entry', id);
};
export const archiveEntry = (id) => {
    const saved = get(savedEntries);
    saved[id].archived = true;
    savedEntries.set(saved);
    console.debug('Archived entry', id);
};
